<template>
  <div>
    <div class="caption mb-2">
      {{ training.title }}<span v-if="training.price_incl > 0">: €{{ training.price_incl | currency }}</span>
    </div>
    <v-radio-group v-model="selected" row>
      <v-radio
        v-for="date in training.date_options"
        :key="date.id"
        :label="$moment(date.date_time).format('D MMMM YYYY - HH:mmu')"
        :value="date"
      />
      <v-radio label="Geen" :value="0"/>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    training: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selected: 0,
  }),
  watch: {
    selected() {
      this.$emit('input', this.selected ? {
        id: this.training.id,
        title: this.training.title,
        price_excl: parseFloat(this.training.price_excl),
        price_incl: parseFloat(this.training.price_incl),
        date: this.selected.date_time,
        dateId: this.selected.id,
      } : null);
    },
  },
};
</script>
